// Pure, DOM-free helpers for the desktop owner-claim screen so they can be unit
// tested without rendering. No logging, storage, or telemetry here.

export const OWNER_EMAIL = "mm@titanhavengroup.com";
export const MIN_PASSWORD = 12;

// Client-side gate before hitting the backend. Returns an error string or null.
export function validateOwnerClaim(secret, password) {
  if (!secret || secret.trim().length === 0) return "Enter the one-time owner secret.";
  if (!password || password.length < MIN_PASSWORD) return `Choose a password with at least ${MIN_PASSWORD} characters.`;
  return null;
}

// Map a failure to a plain, NON-revealing message. Never discloses whether the
// secret was wrong, whether the feature is enabled, or any backend internal.
export function ownerClaimMessage(err) {
  if (err && err.code === "network") return "Network error. Please check your connection and try again.";
  switch (err && err.httpStatus) {
    case 404: return "Owner claim isn't available, or the one-time secret is incorrect.";
    case 409: return "Owner access has already been set up. Please sign in instead.";
    case 400:
    case 422: return "Please check your entries and try again.";
    default: return "Something went wrong. Please try again.";
  }
}
